(() => {
  const normalizeIndexSortUrl = () => {
    const select = document.querySelector('[data-uis24-catalog-sort][data-uis24-catalog-clean-default-url="true"]');
    if (!select) return;

    const defaultSortBy = select.dataset.uis24CatalogDefaultSort;
    const currentUrl = new URL(window.location.href);

    if (!defaultSortBy || currentUrl.searchParams.get('sort_by') !== defaultSortBy) return;

    currentUrl.searchParams.delete('sort_by');
    window.history.replaceState(window.history.state, '', currentUrl.pathname + currentUrl.search + currentUrl.hash);
  };

  normalizeIndexSortUrl();

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-uis24-catalog-sort]');
    if (!select) return;

    const currentUrl = new URL(window.location.href);
    const url = new URL(select.dataset.uis24CatalogUrl || currentUrl.pathname, currentUrl.origin);

    for (const [key, value] of currentUrl.searchParams) {
      if (key !== 'page' && key !== 'sort_by') {
        url.searchParams.append(key, value);
      }
    }

    if (select.dataset.uis24CatalogCleanDefaultUrl === 'true'
      && select.value === select.dataset.uis24CatalogDefaultSort) {
      url.searchParams.delete('sort_by');
    } else {
      url.searchParams.set('sort_by', select.value);
    }

    window.location.assign(url.toString());
  });
})();
